var map = {
	"./About.vue": [
		"f820",
		"chunk-2d22d746"
	],
	"./Home.vue": [
		"bb51",
		"chunk-101f5d0d"
	],
	"./News.vue": [
		"a2f9",
		"chunk-2d20813a"
	],
	"./Page.vue": [
		"2048",
		"chunk-2d0b1638"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;